import React from 'react';
import {Puff} from "react-loader-spinner";

const Loader = () => {
    return(
        <div className="quizz__loader"><Puff color="#6F1C75" height={80} width={80}/></div>
    )
}

export default Loader;